import { render, staticRenderFns } from "./DetailDoorphone.vue?vue&type=template&id=0279645e&scoped=true"
import script from "./DetailDoorphone.vue?vue&type=script&lang=js"
export * from "./DetailDoorphone.vue?vue&type=script&lang=js"
import style0 from "./DetailDoorphone.vue?vue&type=style&index=0&id=0279645e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279645e",
  null
  
)

export default component.exports